.signalsSuccess {
  font-size: 18px;
  font-weight: 200;
  text-align: center;
  line-height: 1.56;
  position: relative;
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  font-family: "Inter", sans-serif;
}

.signalsSuccessTitle h2 {
  font-size: 40px;
  color: var(--form-text-success-color);
  font-family: "CornerDisplay", sans-serif;
}

.signalsSuccessTitle h2 i {
  font-size: 80px;
  display: block;
  margin-bottom: 24px;
}

div.signalsSuccessSubTitle {
  text-align: center;
}

div.signalsSuccessSubTitle h4 {
  color: var(--form-text-color);
  font-size: 24px;
}

.signalsSuccess button {
  font-family: "Lexend", sans-serif;
}

.customButton button.closeButton,
.customButton button.closeButton:hover {
  background-color: transparent !important;
  color: var(--form-btn-color) !important;
  border: none !important;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.33;
  opacity: 1 !important;
  cursor: pointer;
  font-family: "CornerDisplay", sans-serif;
}
.customButton button.closeButton:hover {
  text-decoration: underline !important;
}
